// extracted by mini-css-extract-plugin
export default {"root":"notFoundBlock_root__WMBhK","text":"notFoundBlock_text__fUT07"};